import { render, staticRenderFns } from "./CopyStakeWebAiStreamerProfilesTab.vue?vue&type=template&id=674ac313&scoped=true&lang=pug"
import script from "./CopyStakeWebAiStreamerProfilesTab.vue?vue&type=script&lang=ts"
export * from "./CopyStakeWebAiStreamerProfilesTab.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeWebAiStreamerProfilesTab.vue?vue&type=style&index=0&id=674ac313&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674ac313",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VIcon})
